import { default as types } from "./types";

const {
  FETCH_TT11_1_REPORT_REQUEST,
  FETCH_TT11_1_REPORT_SUCCESS,
  FETCH_TT11_1_REPORT_FAILURE,
} = types;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TT11_1_REPORT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_TT11_1_REPORT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_TT11_1_REPORT_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
